import { apiClient } from "features/shared/api/axiosInstance";
import type { PaginatedScheduledMintDto } from "common/models/api/models/PaginatedScheduledMintDto";
import type { PaginatedTransactionsDto } from "common/models/api/models/PaginatedTransactionsDto";
import type { RangeStatsDto } from "common/models/api/models/RangeStatsDto";
import type { ScheduledMint } from "common/models/api/models/ScheduledMint";
import type { TransactionDto } from "common/models/api/models/TransactionDto";
import type { TransactionKpisDto } from "common/models/api/models/TransactionKpisDto";
import type { UpdateScheduledMintRequest } from "common/models/api/models/UpdateScheduledMintRequest";

type RoleType = "organization-owner" | "operation-manager" | "program-manager" | "partner" | "customer-service";

export const transactionsApi = {
    findAll: (params: {
        page?: number;
        pageSize?: number;
        query?: string;
        address?: string;
        order?: "ASC" | "DESC";
        orderBy?: string;
        startDate?: number;
        endDate?: number;
    }) => apiClient.get<PaginatedTransactionsDto>("/api/transactions/all", { params }),

    kpis: (organizationAddress: string) =>
        apiClient.get<TransactionKpisDto>("/api/transactions/kpis", {
            params: { organizationAddress },
        }),

    getTransactionsByDay: (tokenAddress: string, numberOfSamples?: number) =>
        apiClient.get<RangeStatsDto>("/api/transactions/transactions-by-day", {
            params: { tokenAddress, numberOfSamples },
        }),

    export: (params?: {
        query?: string;
        order?: "ASC" | "DESC";
        orderBy?: string;
        roleFilter?: RoleType;
        startDate?: string;
        endDate?: string;
        scheduledMint?: boolean;
    }) => apiClient.get<string>("/api/transactions/export", { params }),

    manualSync: (userAddress: string, dryRun: boolean) =>
        apiClient.get<string>(`/api/transactions/manual-sync/${userAddress}`, {
            params: { dryRun },
        }),

    findByPaymentGateway: (params: { receiverAddress: string; amount: string; paymentId: string; concept?: string; reference?: string }) =>
        apiClient.get<TransactionDto>("/api/transactions/find-by-payment-gateway", {
            params,
        }),

    // Scheduled Mint
    scheduledMintFindAll: (params: {
        page?: number;
        pageSize?: number;
        query?: string;
        address?: string;
        order?: "ASC" | "DESC";
        orderBy?: string;
        startDate?: number;
        endDate?: number;
    }) => apiClient.get<PaginatedScheduledMintDto>("/api/scheduled-mint", { params }),

    scheduledMintUpdateStatus: (id: string, body: UpdateScheduledMintRequest) =>
        apiClient.put<ScheduledMint>(`/api/scheduled-mint/status/${id}`, body),
};
